import { Skeleton } from 'antd';
import styles from './CategoriesTableSkeleton.module.scss';

interface CategoriesTableSkeletonProps {
  rows?: number;
}

export function CategoriesTableSkeleton({ rows = 10 }: CategoriesTableSkeletonProps) {
  return (
    <div className={styles.wrap} aria-hidden>
      <div className={styles.header}>
        <span className={styles.headerCell} />
        <span className={styles.headerCell} />
        <span className={styles.headerCell}>NAME</span>
        <span className={styles.headerCell}>STATUS</span>
        <span className={styles.headerCell}>SORT</span>
        <span className={styles.headerCell}>UPDATED</span>
        <span className={styles.headerCell}>ACTION</span>
      </div>
      <div className={styles.body}>
        {Array.from({ length: rows }, (_, index) => (
          <div key={index} className={styles.row}>
            <Skeleton.Button active size="small" className={styles.check} />
            <span className={styles.dragPlaceholder} />
            <div className={styles.nameCell}>
              <Skeleton.Avatar active size={32} shape="square" className={styles.thumb} />
              <div className={styles.name}>
                <Skeleton.Input active size="small" />
                <Skeleton.Input active size="small" className={styles.slug} />
              </div>
            </div>
            <Skeleton.Button active size="small" className={styles.status} />
            <Skeleton.Button active size="small" className={styles.sort} />
            <Skeleton.Input active size="small" className={styles.date} />
            <Skeleton.Button active size="small" className={styles.action} />
          </div>
        ))}
      </div>
    </div>
  );
}
